export const CC_AVENUES_RESET_STATE = 'CC_AVENUES_RESET_STATE';
export const CC_AVENUES_CURRENT_ITEM = 'CC_AVENUES_CURRENT_ITEM';

export const CC_AVENUES_REQUEST_LOADING = 'CC_AVENUES_REQUEST_LOADING';
export const CC_AVENUES_REQUEST_SUCCESS = 'CC_AVENUES_REQUEST_SUCCESS';
export const CC_AVENUES_REQUEST_FAILED = 'CC_AVENUES_REQUEST_FAILED';

export const CC_AVENUES_CURRENT_ACTION = 'CC_AVENUES_CURRENT_ACTION';
export const CC_AVENUES_RESET_ACTION = 'CC_AVENUES_RESET_ACTION';